import { BaseModule } from "../../../composition/module/BaseModule";
import { ParamDescription } from "../../../composition/module/ParamDescription";
import { HourlyBonusModuleFlowExecutor } from "./HourlyBonusModuleFlowExecutor";
import { HourlyBonusResourcePackage } from "./mainHourlyBonus/resources/HourlyBonusResourcePackage";
import { HourlyBonusPopupScene, HourlyBonusSceneOptions } from "./mainHourlyBonus/HourlyBonusPopupScene";
import { HourlyBonusExecutionOptions, HourlyBonusType } from "./HourlyBonusExecutionOptions";
import { CheckoutHourlyBonusController } from "./checkouthourlybonus/controller/CheckoutHourlyBonusController";
import { CheckoutHourlyBonusPopupScene, CheckoutHourlyBonusSceneOptions } from "./checkouthourlybonus/view/CheckoutHourlyBonusPopupScene";

export class HourlyBonusModule extends BaseModule<void> {
    private hourlyBonusResourcePackage: HourlyBonusResourcePackage;

    public override async build(): Promise<void> {
        this.internalContainer.register(HourlyBonusModuleFlowExecutor, HourlyBonusModuleFlowExecutor);

        this.internalContainer.register(HourlyBonusPopupScene, HourlyBonusPopupScene);
        this.internalContainer.register("HourlyBonusSceneFactory", {
            useValue: async (options: HourlyBonusSceneOptions) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    HourlyBonusPopupScene,
                    new ParamDescription("HourlyBonusSceneOptions", options)
                );
            }
        });

        this.internalContainer.register(CheckoutHourlyBonusPopupScene, CheckoutHourlyBonusPopupScene);
        this.internalContainer.register("ICheckoutHourlyBonusController", CheckoutHourlyBonusController);
        this.internalContainer.register("CheckOutHourlyBonusPopupSceneFactory", {
            useValue: async (options: CheckoutHourlyBonusSceneOptions) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    CheckoutHourlyBonusPopupScene,
                    new ParamDescription("CheckoutHourlyBonusSceneOptions", options)
                );
            }
        });

        this.hourlyBonusResourcePackage = new HourlyBonusResourcePackage();
        await this.hourlyBonusResourcePackage.load();
        this.internalContainer.registerInstance(HourlyBonusResourcePackage, this.hourlyBonusResourcePackage);

        await super.build();
    }

    public async start<T extends HourlyBonusType>(options?: HourlyBonusExecutionOptions<T>): Promise<void> {
        const executor = await this.internalContainer.resolve(HourlyBonusModuleFlowExecutor);
        await executor.execute(this, options);
        this.dispose();
    }

    public override dispose(): void {
        this.hourlyBonusResourcePackage?.destroy();
        super.dispose();
    }
}